import { useAuth0 } from '@auth0/auth0-react';

const useAuthServer = () => {
  const { loginWithRedirect, logout, getAccessTokenSilently } = useAuth0();
  
  const handleLogout = () => {
    logout({ 
      logoutParams: { returnTo: window.location.origin }
    });
  };

  return {
    handleLogin: loginWithRedirect,
    handleLogout,
    handleAccessToken: getAccessTokenSilently
  };
};

export default useAuthServer